
import { defineComponent, computed } from "vue";
import store from "../store";

export default defineComponent({
    methods: {
        async reveal(e: Event) {
            if (!this.revealed && !this.found)
                await store.dispatch("revealCard", { index: this.index });
        }
    },
    name: "memory-card",
    props: {
        index: { type: Number, required: true },
        name: { type: String, required: true },
        description: { type: String, required: false },
        revealed: { type: Boolean, required: true },
        found: { type: Boolean, required: true },
        link: { type: String, required: false }
    }
});
